import React from 'react';
import OutlinePanel from './OutlinePanel';
import PdfPreview from '../PdfPreview';

const TabButton = ({ active, label, onClick }) => (
    <button onClick={onClick}
        className={`px-3 py-1.5 text-xs font-semibold uppercase tracking-[0.18em] rounded-md transition-colors ${
            active ? 'text-cyan-400 bg-white/5' : 'text-neutral-500 hover:text-white'}`}>
        {label}
    </button>
);

const PreviewBody = ({ initializing, ready, compiling, engineError, pdf, compileError, onRetryInit }) => {
    if (engineError) return (
        <div className="text-center py-10 space-y-3">
            <p className="text-sm text-neutral-400">Preview engine failed to load.</p>
            <button onClick={onRetryInit} className="bg-white/10 hover:bg-white/20 text-white text-sm py-1.5 px-4 rounded-lg">Retry</button>
        </div>
    );
    if (initializing) return (
        <div className="text-center py-10 space-y-3">
            <div className="w-8 h-8 border-4 border-cyan-500 border-t-transparent rounded-full animate-spin mx-auto" />
            <p className="text-xs text-neutral-400 leading-snug px-2">Preparing the preview engine — the first time takes a moment, after that it's instant.</p>
        </div>
    );
    if (!pdf) return (
        <div className="text-center py-10 space-y-3">
            <div className="w-8 h-8 border-4 border-cyan-500 border-t-transparent rounded-full animate-spin mx-auto" />
            <p className="text-xs text-neutral-400">Rendering preview…</p>
        </div>
    );
    return (
        <div className="space-y-2">
            {compileError && <p className="text-xs text-amber-400">Preview couldn't compile — open Finish Up &amp; Preview for the full log.</p>}
            <PdfPreview pdf={pdf} compiling={compiling} />
        </div>
    );
};

const PreviewPanel = ({ tab, onTabChange, sections, onNavigate, preview }) => (
    <aside className="hidden lg:block lg:sticky lg:top-24 lg:w-64 lg:shrink-0">
        <div className="rounded-xl border border-white/10 bg-[#0b0e14]/60 p-5">
            <div className="flex items-center gap-1 mb-4">
                <TabButton active={tab === 'outline'} label="Outline" onClick={() => onTabChange('outline')} />
                <TabButton active={tab === 'preview'} label="Preview" onClick={() => onTabChange('preview')} />
            </div>
            {tab === 'outline'
                ? <OutlinePanel sections={sections} onNavigate={onNavigate} embedded />
                : <PreviewBody {...preview} />}
        </div>
    </aside>
);

export default PreviewPanel;
